import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../app/providers/AuthProvider';
import { BOTTOM_NAV, NAV_GROUPS } from '../../../lib/navigation';
import { cn } from '../../../utils/cn';
import { Icon } from '../../ui/Icon/Icon';
import { isActivePath } from '../Sidebar/Sidebar';

const ALL_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

/** Tab bar at the bottom of the screen on phones. "More" opens the sidebar drawer. */
export function BottomNav({ onMore }: { onMore: () => void }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items = ALL_ITEMS.filter((i) => BOTTOM_NAV.includes(i.to) && !!user && i.roles.includes(user.role));

  return (
    <nav className="pb-safe fixed inset-x-0 bottom-0 z-30 border-t border-line bg-white lg:hidden" aria-label="Quick">
      <div className="grid h-16" style={{ gridTemplateColumns: `repeat(${items.length + 1}, minmax(0, 1fr))` }}>
        {items.map((item) => {
          const active = isActivePath(pathname, item);
          return (
            <Link
              key={item.to}
              to={item.to}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'relative flex flex-col items-center justify-center gap-1 text-[11px] font-medium outline-none focus-visible:bg-navy-50',
                active ? 'text-brand-600' : 'text-ink-400',
              )}
            >
              {active && <span className="absolute inset-x-5 top-0 h-[2px] rounded-b-full bg-brand-600" />}
              <Icon name={item.icon} size={22} strokeWidth={active ? 2.1 : 1.8} />
              {user?.role === 'worker' && item.workerLabel ? item.workerLabel : item.shortLabel ?? item.label}
            </Link>
          );
        })}
        <button type="button" onClick={onMore} className="flex flex-col items-center justify-center gap-1 text-[11px] font-medium text-ink-400 outline-none focus-visible:bg-navy-50">
          <Icon name="menu" size={22} />
          More
        </button>
      </div>
    </nav>
  );
}

export default BottomNav;
